import { useState, useEffect } from "react";
import RecentMatches from "../components/RecentMatches";
import MatchTabs from "../components/MatchTabs";
import UpcomingMatches from "../components/UpcomingMatches";

// To fix TypeScript error: "{}" is not assignable to "UpcomingMatchTableProps"
// (this is caused by a confusion between UpcomingMatches and UpcomingMatchTable)
// To solve this, we need to explicitly tell TypeScript that UpcomingMatches has no required props

const MatchesPage = () => {
    const [activeTab, setActiveTab] = useState('upcoming');
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // Keep track of window resizing to handle mobile layout changes
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="container">
            <div className={`text-center ${isMobile ? 'mb-2' : 'mb-3'}`}>
                <h1 className={isMobile ? 'fs-2' : ''}>Kampe</h1>
                <p className={isMobile ? 'mb-2' : ''}>Se kommende kampe og resultater fra tidligere kampe</p>
            </div>
            <hr className={isMobile ? 'my-2' : ''} />
            <div className="container">
                <MatchTabs onTabChange={setActiveTab} />
            </div>
            <hr className={isMobile ? 'my-2' : ''} />

            {activeTab === 'upcoming' && (
                <div>
                    {/* Using UpcomingMatches with empty object to satisfy TypeScript */}
                    <UpcomingMatches />
                </div>
            )}

            {activeTab === 'results' && (
                <div>
                    <RecentMatches compact={isMobile} />
                </div>
            )}
        </div>
    );
}

export default MatchesPage;